var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var Point = require('./point');
var modal = require('../../layout/components/modal')
var button = require('../../components/button');
var plainButton = require('../../components/plainButton');
var pointCommands = require('../components/pointCommands');
var writeCommandEvents = require('../writeCommandEvents');
var writeOperations = require('../writeOperation');
var pointSubscriber = require('../../components/pointSubscriberClass');


var mod = Object.create(Model);

mod.name = 'Override';
mod['@class'] = 'Point';
mod.url = 'point';
mod.noAutoClose = true;
mod.fields = {
  overridevalue: {},
  overridemode : {}
};

mod.vm = {};
mod._initGeneration = 0;
mod._saveGeneration = 0;

mod.errors = [];

mod.pointUpdateSuppressionRids = function (columnRecord) {
  return [columnRecord && columnRecord.in && columnRecord.in['@rid']];
};

function normalizeRid(rid) {
  if (rid && typeof rid === 'object') {
    rid = rid['@rid'];
  }
  if (typeof rid !== 'string' || !rid) {
    return null;
  }
  return rid[0] === '#' ? rid.slice(1) : rid;
}

function pad2(value) {
  return String(value).padStart(2, '0');
}

function datetimeLocalFromTimestamp(timestamp) {
  var ts = Number(timestamp);
  if (!Number.isFinite(ts) || ts <= 0) {
    return '';
  }
  var date = new Date(ts);
  return [
    date.getFullYear(),
    '-',
    pad2(date.getMonth() + 1),
    '-',
    pad2(date.getDate()),
    'T',
    pad2(date.getHours()),
    ':',
    pad2(date.getMinutes())
  ].join('');
}

function timestampFromDatetimeLocal(value) {
  if (!value) return null;
  var ts = new Date(value).getTime();
  return Number.isFinite(ts) ? ts : null;
}

function formatScheduleTime(timestamp) {
  var ts = Number(timestamp);
  if (!Number.isFinite(ts) || ts <= 0) {
    return '';
  }
  return new Date(ts).toLocaleString();
}

function activeSchedule(scheduleRecord) {
  return scheduleRecord && ['pending', 'retry', 'canceling', 'processing'].indexOf(scheduleRecord.status) !== -1;
}

function overrideError(message) {
  mod.errors = [message];
  m.redraw();
  return false;
}

function errorMessage(error, fallback) {
  return (error && (error.error || error.message)) || String(error || fallback || 'Unknown error');
}

function isSupportedDirectBacnetProperty(resource) {
  if (!resource || resource['@class'] !== 'BacnetProperty') return false;
  var propertyId = Number(resource.propertyId);
  return propertyId === 85 || propertyId === 87;
}

function hasLinkedOverrideTargets(pointRecord) {
  return !!(
    pointRecord &&
    pointRecord.overridemode && pointRecord.overridemode.in &&
    pointRecord.overridevalue && pointRecord.overridevalue.in
  );
}

function hasAnyLinkedOverrideTarget(pointRecord) {
  return !!(
    pointRecord &&
    (pointRecord.overridemode && pointRecord.overridemode.in ||
      pointRecord.overridevalue && pointRecord.overridevalue.in)
  );
}

function overrideAppliedWarning(detail) {
  var message = String(detail || 'a follow-up operation failed').trim();
  if (message) {
    message = message.charAt(0).toLowerCase() + message.slice(1);
  }
  return 'Override applied, but ' + message;
}

function confirmedSourceValue(sourcePoint, userValue, commandValue, direct) {
  if (direct) return commandValue;
  if (!sourcePoint) return commandValue;
  if (sourcePoint.unit === 'bool') return Number(Boolean(Number(userValue)));
  return Point.writeValue({
    scale: sourcePoint.scale,
    unit: sourcePoint.unit,
    destUnit: sourcePoint.destUnit,
    displayUnit: sourcePoint.displayUnit,
    offset: sourcePoint.offset
  }, userValue);
}

mod.initForm = async function (columnRecord, parentRid) {
  var initGeneration = mod._initGeneration + 1;
  mod._initGeneration = initGeneration;
  function isCurrentInitialization() {
    return mod._initGeneration === initGeneration;
  }

  var fallbackPointName = (columnRecord && (columnRecord.name || (columnRecord.in && columnRecord.in.name))) || 'Point';
  columnRecord.customModalTitle = columnRecord.customModalTitle || `Override Point: ${fallbackPointName}`;

  // This model is shared by every override modal. Clear all command-bearing
  // state synchronously so a fast reopen can never submit helper data left by
  // the previous point while the new requests are still loading.
  mod.errors = [];
  mod.successes = [];
  mod.form = null;
  mod.vm.column = columnRecord;
  mod.vm.parentRid = parentRid;
  mod.vm.point = null;
  mod.vm.overridemodePointData = null;
  mod.vm.overridevaluePointData = null;
  mod.vm.overridemode = null;
  mod.vm.overridevalue = null;
  mod.vm.initializationError = null;
  mod.vm.path = [];
  mod.vm.activeTab = prop('command');
  mod.vm.defaultButtons = null;
  mod.vm.buttonsInitialized = false;
  mod.vm.relinquishSchedule = prop(null);
  mod.vm.relinquishScheduleLoading = prop(false);
  mod.vm.relinquishScheduleSaving = prop(false);
  mod.vm.writeOperations = {};

  try {
    const pointResult = await loaders.requestWithLoader({
      loader: 'background',
      url: `/api/v1/point/${columnRecord.in['@rid'].slice(1)}`,
      method: 'GET',
    });
    if (!isCurrentInitialization()) return false;

    const columnResult = await loaders.requestWithLoader({
      loader: 'background',
      url: `/api/v1/column/${columnRecord['@rid'].slice(1)}`,
      method: 'GET',
    });
    if (!isCurrentInitialization()) return false;

    // Build a modal-local breadcrumb without mutating the upstream record
    const basePath = Array.isArray(columnResult.path) ? columnResult.path.slice() : [];
    mod.vm.path = basePath.concat([{
      name: columnResult.name,
      '@class': columnResult['@class'],
      '@rid': columnResult['@rid'],
    }]);

    mod.vm.point = pointResult;
    mod.vm.increment = Number(columnRecord.in.increment) || 1;
    Model.initForm.call(mod, columnRecord);
    mod.form.relinquishScheduleMode = prop('none');
    mod.form.relinquishDuration = prop(1);
    mod.form.relinquishDurationUnit = prop('hours');
    mod.form.relinquishAt = prop('');

    const normalizedParentRid = normalizeRid(parentRid);
    if (normalizedParentRid) {
      mod.vm.relinquishScheduleLoading(true);
      loaders.requestWithLoader({
        loader: 'background',
        url: `/api/v1/override-relinquish-schedule/point/${encodeURIComponent(pointResult['@rid'].slice(1))}?parentRid=${encodeURIComponent(normalizedParentRid)}`,
        method: 'GET',
      }).then(function (scheduleRecord) {
        if (!isCurrentInitialization()) return;
        mod.vm.relinquishSchedule(scheduleRecord || null);
        if (activeSchedule(scheduleRecord)) {
          mod.form.relinquishScheduleMode('at');
          mod.form.relinquishAt(datetimeLocalFromTimestamp(scheduleRecord.releaseAt));
        }
      }).catch(function (error) {
        if (!isCurrentInitialization()) return;
        console.error('Failed to load override relinquish schedule:', error);
      }).then(function () {
        if (!isCurrentInitialization()) return;
        mod.vm.relinquishScheduleLoading(false);
        m.redraw();
      });
    }

    let overridemodeResult, overridevalueResult;
    const hasOverrideModeTarget = !!(mod.vm.point && mod.vm.point.overridemode && mod.vm.point.overridemode.in);
    const hasOverrideValueTarget = !!(mod.vm.point && mod.vm.point.overridevalue && mod.vm.point.overridevalue.in);
    const isDirectBacnetPoint = !!(
      mod.vm.point &&
      isSupportedDirectBacnetProperty(mod.vm.point.resource) &&
      !hasOverrideModeTarget &&
      !hasOverrideValueTarget
    );
    if (isDirectBacnetPoint) {
      overridemodeResult = mod.vm.point;
      overridevalueResult = mod.vm.point;
    } else if (hasOverrideModeTarget && hasOverrideValueTarget) {
      [overridemodeResult, overridevalueResult] = await Promise.all([
         loaders.requestWithLoader({
           loader: 'background',
           url: `/api/v1/point/${pointResult.overridemode.in.slice(1)}`,
           method: 'GET',
         }),
         loaders.requestWithLoader({
           loader: 'background',
           url: `/api/v1/point/${pointResult.overridevalue.in.slice(1)}`,
           method: 'GET',
         }),
       ]);
    } else if (
      mod.vm.point &&
      mod.vm.point.resource &&
      mod.vm.point.resource['@class'] === 'BacnetProperty' &&
      !hasOverrideModeTarget &&
      !hasOverrideValueTarget
    ) {
      throw new Error('Direct override is supported only for BACnet Present Value (85) and Priority Array (87) properties.');
    } else {
      throw new Error('Point override topology is incomplete or unavailable.');
    }
    if (!isCurrentInitialization()) return false;

    mod.vm.overridemodePointData = overridemodeResult;
    mod.vm.overridevaluePointData = overridevalueResult;

    mod.vm.overridemode = overridemodeResult;
    mod.vm.overridevalue = overridevalueResult;

    // Handle enumeration, boolean, and numeric for overridemode
    // Ignore enumeration for boolean units

    if (mod.vm.overridemodePointData.unit === 'bool') {
      mod.form.overridemode = prop(Boolean(Number(mod.vm.point.overrideActive)));
    } else if (mod.vm.overridemodePointData.enumeration) {
      mod.form.overridemode = prop(mod.vm.point.overrideActive);
    } else if (mod.vm.overridemodePointData.resource['@class'] == 'BacnetProperty') {
      mod.form.overridemode = prop(Boolean(Number(mod.vm.point.overrideActive)));
    } else {
      mod.form.overridemode = prop(Point.readValue({
        value: mod.vm.overridemode.value || 0,
        unit: mod.vm.overridemode.unit || columnRecord.in.unit,
        destUnit: mod.vm.overridemode.destUnit || columnRecord.in.destUnit,
        displayUnit: mod.vm.overridemode.displayUnit || columnRecord.in.displayUnit,
      }));
    }

    // Handle enumeration, boolean, and numeric for overridevalue
    // Booleans should not use enumeration mappings
    if (mod.vm.point.unit === 'bool') {
      mod.form.overridevalue = prop(Number(mod.vm.overridevalue.value));
    } else if (mod.vm.overridevaluePointData.enumeration) {
      mod.form.overridevalue = prop(mod.vm.overridevalue.value);
    } else {
      mod.form.overridevalue = prop(Point.readValue({
        value: parseFloat(mod.vm.overridevalue.value) || 0,
        unit: mod.vm.overridevalue.unit || columnRecord.in.unit,
        destUnit: mod.vm.overridevalue.destUnit || columnRecord.in.destUnit,
        displayUnit: mod.vm.overridevalue.displayUnit || columnRecord.in.displayUnit,
      }));
      mod.vm.increment = Number(mod.vm.overridevalue.increment) || Number(columnRecord.in.increment) || 1;
    }
  } catch (error) {
    if (!isCurrentInitialization()) return false;
    mod.vm.initializationError = errorMessage(error, 'Point override data could not be loaded.');
    console.error("Error initializing form:", error);
    mod.errors.push(JSON.stringify(error));
    // Fallback so command controls still render if point/column lookup fails.
    try {
      if (!mod.form) {
        Model.initForm.call(mod, columnRecord || {});
      }
      mod.form.relinquishScheduleMode = mod.form.relinquishScheduleMode || prop('none');
      mod.form.relinquishDuration = mod.form.relinquishDuration || prop(1);
      mod.form.relinquishDurationUnit = mod.form.relinquishDurationUnit || prop('hours');
      mod.form.relinquishAt = mod.form.relinquishAt || prop('');
      var pointFallback = (columnRecord && columnRecord.in) ? columnRecord.in : {};
      mod.vm.point = pointFallback;
      mod.vm.overridemodePointData = mod.vm.overridemodePointData || pointFallback;
      mod.vm.overridevaluePointData = mod.vm.overridevaluePointData || pointFallback;
      mod.vm.overridemode = mod.vm.overridemode || pointFallback;
      mod.vm.overridevalue = mod.vm.overridevalue || pointFallback;
      mod.vm.increment = Number(pointFallback.increment) || mod.vm.increment || 1;
      mod.form.overridemode = prop(Boolean(Number(pointFallback.overrideActive || 0)));
      if (pointFallback.unit === 'bool') {
        mod.form.overridevalue = prop(Number(pointFallback.value || 0));
      } else {
        mod.form.overridevalue = prop(Point.readValue({
          value: Number(pointFallback.value || 0),
          unit: pointFallback.unit,
          destUnit: pointFallback.destUnit,
          displayUnit: pointFallback.displayUnit,
          scale: pointFallback.scale,
          offset: pointFallback.offset,
        }));
      }
    } catch (fallbackError) {
      console.error('Error applying override modal fallback state:', fallbackError);
    }
  }
};

mod.resolveRelinquishReleaseAt = function () {
  var mode = mod.form && mod.form.relinquishScheduleMode ? mod.form.relinquishScheduleMode() : 'none';
  if (mode === 'none') return null;

  if (mode === 'duration') {
    var amount = Number(mod.form.relinquishDuration && mod.form.relinquishDuration());
    if (!Number.isFinite(amount) || amount <= 0) {
      throw new Error('Relinquish duration must be greater than zero.');
    }
    var unit = mod.form.relinquishDurationUnit && mod.form.relinquishDurationUnit();
    var multiplier = unit === 'minutes' ? 60 * 1000 : 60 * 60 * 1000;
    return Date.now() + Math.round(amount * multiplier);
  }

  if (mode === 'at') {
    var ts = timestampFromDatetimeLocal(mod.form.relinquishAt && mod.form.relinquishAt());
    if (!ts) {
      throw new Error('Relinquish time is required.');
    }
    return ts;
  }

  return null;
};

mod.cancelRelinquishSchedule = async function (options) {
  options = options || {};
  var scheduleRecord = mod.vm && mod.vm.relinquishSchedule ? mod.vm.relinquishSchedule() : null;
  if (!scheduleRecord || !scheduleRecord['@rid']) return null;
  mod.vm.relinquishScheduleSaving(true);
  try {
    if (typeof scheduleRecord.generation !== 'string' || !scheduleRecord.generation) {
      throw new Error('The scheduled relinquish changed; reload it before canceling.');
    }
    var result = await loaders.requestWithLoader({
      loader: 'background',
      url: `/api/v1/override-relinquish-schedule/${encodeURIComponent(scheduleRecord['@rid'].slice(1))}?generation=${encodeURIComponent(scheduleRecord.generation)}`,
      method: 'DELETE',
    });
    mod.vm.relinquishSchedule(null);
    mod.form.relinquishScheduleMode('none');
    mod.form.relinquishAt('');
    return result;
  } catch (error) {
    if (options.throwOnError) throw error;
    mod.errors.push(errorMessage(error, 'Failed to cancel scheduled relinquish.'));
    return null;
  } finally {
    mod.vm.relinquishScheduleSaving(false);
    m.redraw();
  }
};

mod.syncRelinquishSchedule = async function (modeData, bundledSchedule) {
  var scheduleRecord = mod.vm && mod.vm.relinquishSchedule ? mod.vm.relinquishSchedule() : null;
  var isManual = Number(modeData) === 1;
  var scheduleMode = mod.form && mod.form.relinquishScheduleMode ? mod.form.relinquishScheduleMode() : 'none';
  var parentRid = normalizeRid(mod.vm.parentRid);

  if (!parentRid || !mod.vm.point || !mod.vm.point['@rid']) {
    return null;
  }

  if (!isManual || scheduleMode === 'none') {
    if (activeSchedule(scheduleRecord)) {
      return mod.cancelRelinquishSchedule({ throwOnError: true });
    }
    return null;
  }

  var releaseAt = bundledSchedule && bundledSchedule.releaseAt
    ? Number(bundledSchedule.releaseAt)
    : mod.resolveRelinquishReleaseAt();
  if (!releaseAt || releaseAt <= Date.now()) {
    throw new Error('Scheduled relinquish time must be in the future.');
  }

  mod.vm.relinquishScheduleSaving(true);
  try {
    var result = bundledSchedule || await loaders.requestWithLoader({
        loader: 'background',
        url: '/api/v1/override-relinquish-schedule',
        method: 'POST',
        body: {
          pointRid: mod.vm.point['@rid'],
          parentRid: '#' + parentRid,
          releaseAt: releaseAt
        },
      });
    mod.vm.relinquishSchedule(result || null);
    if (result && result.releaseAt) {
      mod.form.relinquishScheduleMode('at');
      mod.form.relinquishAt(datetimeLocalFromTimestamp(result.releaseAt));
      mod.successes.push('Scheduled relinquish for ' + formatScheduleTime(result.releaseAt));
    }
    return result;
  } finally {
    mod.vm.relinquishScheduleSaving(false);
    m.redraw();
  }
};

mod.save = async function () {
  var initGeneration = mod._initGeneration;
  var saveGeneration = mod._saveGeneration + 1;
  mod._saveGeneration = saveGeneration;
  var activeWriteOperation = null;
  var usedWriteOperations = [];
  var authoritativeReleaseAt = null;
  function ensureCurrentSave() {
    if (initGeneration !== mod._initGeneration || saveGeneration !== mod._saveGeneration) {
      var staleError = new Error(
        initGeneration !== mod._initGeneration
          ? 'The override dialogue changed before this command completed.'
          : 'A newer override command replaced this save before it completed.'
      );
      staleError.code = 'OVERRIDE_DIALOGUE_REPLACED';
      throw staleError;
    }
  }

  try {
    mod.errors = [];
    let valueData;
    const parentRid = normalizeRid(mod.vm.parentRid);

    if (mod.vm.initializationError) {
      return overrideError('Point override data could not be loaded: ' + mod.vm.initializationError);
    }

    if (!mod.vm.point || !mod.vm.overridevaluePointData || !mod.vm.overridemodePointData) {
      return overrideError('Point override data is still loading. Try again in a moment.');
    }

    if (!parentRid) {
      return overrideError('Cannot override point without a parent location or equipment context.');
    }

    const sourcePoint = mod.vm.point;
    const overrideModePointData = mod.vm.overridemodePointData;
    const overrideValuePointData = mod.vm.overridevaluePointData;
    const userOverrideValue = mod.form.overridevalue();
    ensureCurrentSave();

    if (sourcePoint.unit === 'bool') {
      if (overrideModePointData && overrideModePointData.resource && overrideModePointData.resource['@class'] == 'BacnetProperty') {
        valueData = Boolean(Number(userOverrideValue));
      } else {
        valueData = Number(userOverrideValue);
      }
    } else {
      valueData = Point.writeValue(
        {
          scale: mod.vm.overridevalue.scale,
          unit: mod.vm.overridevalue.unit,
          destUnit: mod.vm.overridevalue.destUnit,
          displayUnit: mod.vm.overridevalue.displayUnit,
        },
        userOverrideValue
      );
    }

    const modeData = Number(mod.form.overridemode());
    const scheduleMode = mod.form && mod.form.relinquishScheduleMode
      ? mod.form.relinquishScheduleMode()
      : 'none';
    let relinquishScheduleRequest = null;
    let persistedRelinquishSchedule = null;
    let relinquishScheduleWarnings = [];
    let bundledCancellationHandled = false;
    var relinquishIntent = {
      mode: scheduleMode,
      duration: scheduleMode === 'duration'
        ? Number(mod.form.relinquishDuration && mod.form.relinquishDuration())
        : null,
      durationUnit: scheduleMode === 'duration' &&
        mod.form.relinquishDurationUnit && mod.form.relinquishDurationUnit() || null,
      at: scheduleMode === 'at' && mod.form.relinquishAt && mod.form.relinquishAt() || null,
      active: modeData
    };
    var overrideConflictScope = writeOperations.pointConflictScope(
      sourcePoint['@rid'],
      parentRid
    );
    var overrideConflictGroup = JSON.stringify({
      surface: 'point-override',
      sourcePointRid: sourcePoint['@rid'],
      parentRid: parentRid,
      active: modeData,
      value: modeData === 1 ? userOverrideValue : null,
      relinquish: relinquishIntent
    });
    if (modeData === 0 || scheduleMode === 'none') {
      relinquishScheduleRequest = { action: 'cancel' };
    } else if (modeData === 1) {
        const releaseAt = mod.resolveRelinquishReleaseAt();
        if (!releaseAt) {
          throw new Error('Scheduled relinquish time is invalid.');
        }
        relinquishScheduleRequest = { releaseAt: releaseAt };
        authoritativeReleaseAt = releaseAt;
    }

    // Link all physical phases to one receipt identity. This prevents an old
    // phase receipt from suppressing a reassertion when either helper target,
    // conversion, configuration fingerprint, or initial schedule changed.
    const isDirectBacnetOverride = isSupportedDirectBacnetProperty(sourcePoint.resource) &&
      !hasAnyLinkedOverrideTarget(sourcePoint);
    var receiptTargets;
    if (isDirectBacnetOverride) {
      receiptTargets = [{
        pointData: overrideValuePointData,
        value: modeData === 0 ? null : valueData
      }];
    } else if (modeData) {
      receiptTargets = [
        { pointData: overrideValuePointData, value: valueData },
        { pointData: overrideModePointData, value: modeData }
      ];
    } else {
      receiptTargets = [
        { pointData: overrideModePointData, value: modeData },
        { pointData: overrideValuePointData, value: valueData }
      ];
    }
    var overrideReceiptGroup = JSON.stringify({
      logicalAction: overrideConflictGroup,
      initialRelinquishSchedule: relinquishScheduleRequest,
      targets: receiptTargets.map(function (target) {
        return {
          pointRid: target.pointData && target.pointData['@rid'],
          value: target.value,
          expectedPointConfiguration: Point.expectedPointConfiguration([
            sourcePoint,
            target.pointData
          ])
        };
      })
    });

    async function prepareOverridePointWrite(pointData, body, includeRelinquishSchedule, phaseKey) {
      ensureCurrentSave();
      var requestBody = Object.assign({}, body, {
        sourcePointRid: sourcePoint['@rid'],
        expectedPointConfiguration: Point.expectedPointConfiguration([
          sourcePoint,
          pointData
        ])
      });
      var requestedSchedule = includeRelinquishSchedule === true
        ? relinquishScheduleRequest
        : includeRelinquishSchedule;
      if (requestedSchedule) {
        requestBody.relinquishSchedule = requestedSchedule;
      }
      var url = `/api/v1/point/${pointData['@rid'].slice(1)}/write/${parentRid}`;
      mod.vm.writeOperations = mod.vm.writeOperations || {};
      var operation = await writeOperations.prepare(
        mod.vm.writeOperations,
        phaseKey,
        url,
        requestBody,
        {
          scope: [sourcePoint['@rid'], parentRid, phaseKey].join(':'),
          intent: {
            commandType: 'override',
            active: modeData,
            value: modeData === 1 ? userOverrideValue : null,
            phase: phaseKey,
            relinquish: requestedSchedule === relinquishScheduleRequest
              ? relinquishIntent
              : requestedSchedule || null
          },
          conflictScopes: [overrideConflictScope],
          conflictGroup: overrideConflictGroup,
          receiptGroup: overrideReceiptGroup,
          recoveryPolicy: writeOperations.ATTENDED_RECOVERY_POLICY
        }
      );
      ensureCurrentSave();
      if (requestedSchedule === relinquishScheduleRequest) {
        var durableSchedule = operation.body && operation.body.relinquishSchedule;
        var durableReleaseAt = Number(durableSchedule && durableSchedule.releaseAt);
        if (Number.isFinite(durableReleaseAt) && durableReleaseAt > 0) {
          // A restored initial phase owns the original absolute deadline. Do
          // not extend a duration simply because the client is retrying.
          authoritativeReleaseAt = durableReleaseAt;
        }
      }
      return { operation: operation, key: phaseKey };
    }

    async function requestOverridePointWrite(prepared) {
      ensureCurrentSave();
      if (authoritativeReleaseAt && authoritativeReleaseAt <= Date.now() &&
          prepared.operation.attemptedAt === null) {
        var expired = new Error(
          'Scheduled relinquish deadline elapsed before the next override phase could start.'
        );
        expired.code = 'OVERRIDE_RELINQUISH_EXPIRED';
        expired.overrideRelinquishExpired = true;
        expired.expiringWriteOperation = prepared;
        throw expired;
      }
      await writeOperations.markAttempted(prepared.operation);
      ensureCurrentSave();
      return loaders.requestWithLoader({
        loader: 'submit',
        url: prepared.operation.url,
        method: 'PUT',
        body: prepared.operation.body,
      });
    }

    async function waitForOverridePointWrite(pointData, body, includeRelinquishSchedule, phaseKey) {
      var prepared = await prepareOverridePointWrite(
        pointData,
        body,
        includeRelinquishSchedule,
        phaseKey
      );
      activeWriteOperation = prepared;
      return writeCommandEvents.waitForPointWrite({
        pointRid: writeOperations.pointRidForOperation(prepared.operation),
        request: function () {
          return requestOverridePointWrite(prepared);
        },
        onCommand: function (result) {
          ensureCurrentSave();
          if (result && result.relinquishSchedule) {
            persistedRelinquishSchedule = result.relinquishSchedule;
            mod.vm.relinquishSchedule(result.relinquishSchedule);
            var persistedReleaseAt = Number(result.relinquishSchedule.releaseAt);
            if (Number.isFinite(persistedReleaseAt) && persistedReleaseAt > 0) {
              authoritativeReleaseAt = authoritativeReleaseAt
                ? Math.min(authoritativeReleaseAt, persistedReleaseAt)
                : persistedReleaseAt;
            }
          }
          if (result && result.relinquishScheduleWarning && relinquishScheduleWarnings.indexOf(result.relinquishScheduleWarning) === -1) {
            relinquishScheduleWarnings.push(result.relinquishScheduleWarning);
          }
          if (result && result.relinquishScheduleCancellation && result.relinquishScheduleCancellation.requested) {
            bundledCancellationHandled = true;
          }
        },
        timeoutMessage: 'Timed out waiting for override confirmation.'
      }).then(function (confirmation) {
        ensureCurrentSave();
        activeWriteOperation = null;
        usedWriteOperations.push(prepared);
        return confirmation;
      });
    }

    function continuationFor(confirmation) {
      const command = confirmation && confirmation.command;
      const generation = command && command.relinquishSchedule && command.relinquishSchedule.generation ||
        command && command.relinquishScheduleCancellation && command.relinquishScheduleCancellation.generation;
      const commandRid = command && command.commandRid;
      if (typeof generation !== 'string' || !generation || !commandRid) {
        throw new Error('The server did not return a confirmed override continuation token.');
      }
      return {
        action: 'continue',
        generation: generation,
        commandRid: commandRid
      };
    }

    let confirmation;
    // Only BACnet Present Value and Priority Array properties support the
    // direct override strategy. All other points require linked helpers.
    if (isDirectBacnetOverride) {
      confirmation = await waitForOverridePointWrite(overrideValuePointData, {
        value: modeData === 0 ? null : valueData,
        commandType: 'override',
        active: modeData
      }, true, 'direct');
    } else if (!hasLinkedOverrideTargets(sourcePoint)) {
      throw new Error('Point does not have a supported direct override property or linked override targets.');
    } else if (modeData) {
      // Store the requested value before enabling Manual. The first write
      // establishes the server-owned mutation generation; the mode write may
      // only continue that exact generation, so a timer or newer user action
      // cannot interleave between the linked writes.
      const valueConfirmation = await waitForOverridePointWrite(overrideValuePointData, {
        value: valueData,
        commandType: 'override',
        active: modeData
      }, true, 'manual-value');
      ensureCurrentSave();
      confirmation = await waitForOverridePointWrite(overrideModePointData, {
        value: modeData,
        commandType: 'override',
        active: modeData
      }, continuationFor(valueConfirmation), 'manual-mode');
    } else {
      // Disable Manual first, then preserve the configured value under the
      // same server-owned generation. Each worker result is confirmed
      // independently so a partial release is not reported as complete.
      const modeConfirmation = await waitForOverridePointWrite(overrideModePointData, {
        value: modeData,
        commandType: 'override',
        active: modeData
      }, true, 'auto-mode');
      ensureCurrentSave();
      confirmation = await waitForOverridePointWrite(overrideValuePointData, {
        value: valueData,
        commandType: 'override',
        active: modeData
      }, continuationFor(modeConfirmation), 'auto-value');
    }
    ensureCurrentSave();
    await writeOperations.completeMany(mod.vm.writeOperations, usedWriteOperations);
    ensureCurrentSave();

    const command = (confirmation && confirmation.command) || {};
    const commandUser = command.user || {};
    const commandUserName = [commandUser.firstName, commandUser.lastName].filter(Boolean).join(' ') || 'unknown user';
    mod.successes.push(`Successfully updated by ${commandUserName} on ${new Date()}`);

    var followUpWarnings = relinquishScheduleWarnings.slice();
    if (relinquishScheduleRequest && relinquishScheduleRequest.action === 'cancel') {
      if (!bundledCancellationHandled) {
        followUpWarnings.push('the server did not confirm the bundled relinquish cancellation.');
      }
      mod.vm.relinquishSchedule(null);
    } else if (relinquishScheduleRequest && !persistedRelinquishSchedule) {
      followUpWarnings.push('the server did not return the persisted relinquish schedule.');
    } else {
      // Timed schedules and explicit no-timer/Auto transitions are returned by
      // the same request that queued the authoritative mode write.
      try {
        ensureCurrentSave();
        await mod.syncRelinquishSchedule(modeData, persistedRelinquishSchedule);
        ensureCurrentSave();
      } catch (scheduleError) {
        ensureCurrentSave();
        followUpWarnings.push('the previous relinquish schedule could not be canceled: ' + errorMessage(scheduleError));
      }
    }

    try {
      ensureCurrentSave();
      await loaders.requestWithLoader({
        loader: 'background',
        url: `/api/v1/point/${sourcePoint['@rid'].slice(1)}/runtime/${parentRid}`,
        method: 'PUT',
        body: {
          sourcePointRid: sourcePoint['@rid'],
          overrideActive: modeData,
          commandRid: command.commandRid
        }
      });
      ensureCurrentSave();
      sourcePoint.overrideActive = modeData;
      if (modeData === 1) {
        var confirmedValue = confirmedSourceValue(
          sourcePoint,
          userOverrideValue,
          valueData,
          isDirectBacnetOverride
        );
        sourcePoint.value = confirmedValue;
        if (mod.vm.column && mod.vm.column.in) {
          mod.vm.column.in.value = confirmedValue;
          mod.vm.column.in.overrideActive = modeData;
        }
        pointSubscriber.publishConfirmedOverrideUpdate({
          rid: sourcePoint['@rid'],
          value: confirmedValue,
          overrideActive: modeData,
          overrideRuntimeCommandRid: command.commandRid
        });
      }
    } catch (runtimeError) {
      ensureCurrentSave();
      followUpWarnings.push('runtime state could not be updated: ' + errorMessage(runtimeError));
    }

    followUpWarnings.forEach(function (warning) {
      mod.errors.push(overrideAppliedWarning(warning));
    });
    loaders.submit.stop();
    m.redraw();

  } catch (error) {
    if (initGeneration !== mod._initGeneration || saveGeneration !== mod._saveGeneration ||
        error && error.code === 'OVERRIDE_DIALOGUE_REPLACED') {
      return false;
    }
    if (error && error.writeApplied) {
      loaders.submit.stop();
      if (error.writeActionComplete) {
        mod.successes.push('This exact override was already confirmed; no duplicate request was sent.');
      } else {
        mod.errors.push(overrideAppliedWarning(
          'a prior override phase was confirmed, but the full action still requires reconciliation.'
        ));
      }
      m.redraw();
      return false;
    }
    var safelyNotInvoked = false;
    if (activeWriteOperation && !(error && error.overrideRelinquishExpired)) {
      try {
        safelyNotInvoked = await writeOperations.fail(
          mod.vm.writeOperations,
          activeWriteOperation.key,
          activeWriteOperation.operation,
          error
        );
      } catch (recoveryError) {
        error = recoveryError;
      }
    }
    var deadlineExpired = authoritativeReleaseAt && authoritativeReleaseAt <= Date.now();
    if ((error && error.overrideRelinquishExpired) ||
        (safelyNotInvoked && deadlineExpired)) {
      var expiringEntries = usedWriteOperations.slice();
      if (error && error.expiringWriteOperation &&
          !expiringEntries.some(function (entry) {
            return entry.operation.id === error.expiringWriteOperation.operation.id;
          })) {
        expiringEntries.push(error.expiringWriteOperation);
      }
      try {
        await writeOperations.expireMany(
          mod.vm.writeOperations,
          expiringEntries,
          usedWriteOperations
        );
        var expiredMessage = 'the scheduled relinquish deadline elapsed before the next phase; no new phase was sent.';
        mod.errors.push(usedWriteOperations.length
          ? overrideAppliedWarning(expiredMessage)
          : 'Override was not sent because the scheduled relinquish deadline elapsed.');
        loaders.submit.stop();
        m.redraw();
        return false;
      } catch (recoveryError) {
        error = recoveryError;
      }
    }
    console.error("Error saving data:", error);
    if (error) {
      var saveErrorMessage = (error && (error.error || error.message)) || String(error);
      mod.errors.push(`Failed update on ${new Date()} with error: ${saveErrorMessage}`);
    }
    loaders.submit.stop();  // Stop the loader on error
    m.redraw();
  }
};


mod.view = function () {
  if(!mod.form) { return }

  function enumerationView() {
    return m('select.form-control', {
      onchange: function(ev) { mod.form.overridevalue(ev.target.value); },
      value: mod.form.overridevalue(),
      style: {
        minWidth: '16rem',
        minHeight: '4rem',
        fontSize: '1.25rem',
      },
    }, Object.keys(mod.vm.overridevaluePointData.enumeration).map(function(key) {
      return m('option', { value: key }, mod.vm.overridevaluePointData.enumeration[key]);
    }));
  }

  const breadcrumbPath = (mod.vm && (mod.vm.path || (mod.vm.column && mod.vm.column.path))) || [];
  const lastValidIdx = Array.isArray(breadcrumbPath) ? (breadcrumbPath.length - 1) : -1;
  const buttonFontSize = '1.2em';

  if (!mod.vm.activeTab) {
    mod.vm.activeTab = prop('command');
  }
  const activeTab = mod.vm.activeTab();
  const controlClusterWidth = '34rem';
  const controlLabelWidth = '6rem';
  const narrowControlBreakpoint = 880;
  const modalControlNarrowThreshold = 1100;

  function controlLabelStyle(overrides) {
    return Object.assign({
      display: 'inline-block',
      textAlign: 'right',
      marginRight: '0.75rem',
      fontSize: '1rem',
      alignSelf: 'center',
      flex: '0 0 ' + controlLabelWidth,
      width: controlLabelWidth,
      minWidth: controlLabelWidth,
      maxWidth: controlLabelWidth,
      boxSizing: 'border-box',
    }, overrides || {});
  }

  function renderCenteredControlRow(content) {
    var modalContent = null;
    if (typeof document !== 'undefined') {
      var modalRoot = document.getElementById('modal-id-to-focus');
      if (modalRoot && modalRoot.children && modalRoot.children.length > 0 && modalRoot.children[0].clientWidth) {
        modalContent = modalRoot.children[0];
      }
    }

    const isNarrow = (typeof window !== 'undefined' && window.innerWidth <= narrowControlBreakpoint) ||
      (modalContent && modalContent.clientWidth <= modalControlNarrowThreshold);

    const activeMaxWidth = isNarrow ? '100%' : controlClusterWidth;

    return m('div', {
      style: {
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
      },
    }, m('div.flex.items-center.mb1', {
      style: {
        width: '100%',
        maxWidth: activeMaxWidth,
      },
    }, content));
  }

  function ensureDefaultButtons() {
    if (!mod.vm.buttonsInitialized && typeof modal?.vm?.buttons === 'function') {
      mod.vm.defaultButtons = modal.vm.buttons().slice();
      mod.vm.buttonsInitialized = true;
    }
  }

  function applyModalButtons(tabKey) {
    if (typeof modal?.vm?.buttons !== 'function') { return; }
    ensureDefaultButtons();
    if (tabKey === 'history') {
      if ((modal.vm.buttons() || []).length !== 0) {
        modal.vm.buttons([]);
      }
    } else if (Array.isArray(mod.vm.defaultButtons) && (modal.vm.buttons() || []).length === 0) {
      modal.vm.buttons(mod.vm.defaultButtons.slice());
    }
  }

  ensureDefaultButtons();
  applyModalButtons(activeTab);

  function setActiveTab(tabKey) {
    mod.vm.activeTab(tabKey);
    applyModalButtons(tabKey);
  }

  function modeAction(label, iconClass, tabKey, testId) {
    function activate() {
      setActiveTab(tabKey);
    }

    return m('div.pointer.ba.bw1.flex.items-center.justify-center', {
      'data-testid': testId,
      role: 'button',
      tabindex: 0,
      style: {
        minHeight: '2.5rem',
        paddingLeft: '0.8rem',
        paddingRight: '0.9rem',
        fontSize: '0.95rem',
        color: '#ddd',
        borderColor: '#777',
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
      },
      onclick: activate,
      onkeydown: function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          activate();
        }
      },
    }, [
      m('i.' + iconClass + '.mr2'),
      label
    ]);
  }

  function renderModeSwitch() {
    return m('div.flex.justify-end.mb3', [
      activeTab === 'history'
        ? modeAction('Back to Command', 'ion-chevron-left', 'command', 'write-modal-command-action')
        : modeAction('View History', 'ion-ios-clock-outline', 'history', 'write-modal-history-action')
    ]);
  }

  function renderOverrideValueControl() {
    const numericControlHeight = '5rem';

    const labelStyle = controlLabelStyle();

    function markManualValueEdit(value) {
      mod.form.overridevalue(value);
      mod.form.overridemode(true);
    }

    function renderBooleanToggle(value, onValue, offValue) {
      var isOn = value === onValue;

      return m('div.flex', [
        m(plainButton, {
          label: 'Off',
          style: {
            width: '7.5rem',
            maxWidth: '7.5rem',
            minWidth: '7.5rem',
            marginRight: '0.5rem',
            fontSize: buttonFontSize,
            height: '4rem',
            minHeight: '4rem',
            maxHeight: '4rem',
            lineHeight: '4rem',
            boxSizing: 'border-box',
          },
          class: !isOn ? 'bg-mid-gray' : '',
          func: function () {
            mod.form.overridevalue(offValue);
          },
        }),
            m(plainButton, {
          label: 'On',
          class: isOn ? 'bg-blue' : '',
          style: {
            width: '7.5rem',
            maxWidth: '7.5rem',
            minWidth: '7.5rem',
            fontSize: buttonFontSize,
            color: isOn ? '#000' : '#fff',
            height: '4rem',
            minHeight: '4rem',
            maxHeight: '4rem',
            lineHeight: '4rem',
            boxSizing: 'border-box',
          },
          func: function () {
            mod.form.overridevalue(onValue);
          },
        })
      ]);
    }

    if (mod.vm.point?.unit === 'bool') {
      return m('div', [
        renderCenteredControlRow([
          m('span.f2', { style: labelStyle }, 'Value'),
          m('div', [
            renderBooleanToggle(Boolean(mod.form.overridevalue()), true, false),
          ]),
        ]),
      ]);
    }

    if (mod.vm?.overridevaluePointData?.enumeration) {
      return m('div', [
        renderCenteredControlRow([
          m('span.f2', { style: labelStyle }, 'Value'),
          enumerationView(),
        ]),
      ]);
    }

    return m('div', [
      renderCenteredControlRow([
        m('span.f2', { style: labelStyle }, 'Value'),
        m('div', {
          style: {
            display: 'inline-flex',
            alignItems: 'center',
          },
        }, [
            m('div.flex', {
              style: {
                alignItems: 'stretch',
              },
            }, [
            m('div', {
              style: {
                width: '13.5rem',
                minWidth: '13.5rem',
                maxWidth: '13.5rem',
                marginRight: '0.5rem',
                alignSelf: 'stretch',
              },
            }, [
              m('input.h4.f-headline', {
                style: {
                  width: '100%',
                  maxWidth: '13.5rem',
                  height: numericControlHeight,
                  maxHeight: numericControlHeight,
                  minHeight: numericControlHeight,
                    boxSizing: 'border-box',
                },
                type: 'number',
                oninput: function (ev) {
                  markManualValueEdit(ev.target.value);
                },
                onchange: function (ev) {
                  markManualValueEdit(ev.target.value);
                },
                onkeyup: function (ev) {
                  markManualValueEdit(ev.target.value);
                },
                value: mod.form.overridevalue()
              })
            ]),
            m('div.flex.flex-column.justify-between', {
              style: {
                width: '6rem',
                minWidth: '6rem',
                maxWidth: '6rem',
                height: numericControlHeight,
                alignSelf: 'stretch',
                gap: '0.25rem',
              },
            }, [
              m(plainButton, {
            label: m('i', {
              style: { fontSize: '1em' },
              class: 'ion-chevron-up',
            }),
            class: '',
            style: {
              width: '6rem',
              maxWidth: '6rem',
              minWidth: '6rem',
              height: 'calc((5rem - 0.25rem) / 2)',
              minHeight: 'calc((5rem - 0.25rem) / 2)',
              maxHeight: 'calc((5rem - 0.25rem) / 2)',
              fontSize: buttonFontSize,
              boxSizing: 'border-box',
            },
                func: function () {
                  markManualValueEdit(Number(mod.form.overridevalue()) + mod.vm.increment);
                }
              }),
              m(plainButton, {
            label: m('i', {
              style: { fontSize: '1em' },
              class: 'ion-chevron-down',
            }),
            class: '',
            style: {
              width: '6rem',
              maxWidth: '6rem',
              minWidth: '6rem',
              height: 'calc((5rem - 0.25rem) / 2)',
              minHeight: 'calc((5rem - 0.25rem) / 2)',
              maxHeight: 'calc((5rem - 0.25rem) / 2)',
              fontSize: buttonFontSize,
              boxSizing: 'border-box',
            },
                func: function () {
                  markManualValueEdit(Number(mod.form.overridevalue()) - mod.vm.increment);
                }
              })
            ])
          ])
        ])
      ])
    ]);
  }

  function isManualMode(value) {
    return value === true || value === 1 || value === '1' || value === 'true' || Number(value) === 1;
  }

  function renderRelinquishScheduleControl() {
    var scheduleRecord = mod.vm && mod.vm.relinquishSchedule ? mod.vm.relinquishSchedule() : null;
    var hasSchedule = activeSchedule(scheduleRecord);
    var manual = isManualMode(mod.form.overridemode());
    var mode = mod.form.relinquishScheduleMode ? mod.form.relinquishScheduleMode() : 'none';
    var saving = mod.vm.relinquishScheduleSaving && mod.vm.relinquishScheduleSaving();
    var loading = mod.vm.relinquishScheduleLoading && mod.vm.relinquishScheduleLoading();
    var labelStyle = controlLabelStyle();
    var smallInputStyle = {
      height: '2.75rem',
      minHeight: '2.75rem',
      maxHeight: '2.75rem',
      boxSizing: 'border-box',
      fontSize: '1rem',
    };

    if (!manual && !hasSchedule) {
      return null;
    }

    function selectMode(nextMode) {
      if (saving) return;
      mod.form.relinquishScheduleMode(nextMode);
      if (nextMode === 'at' && !mod.form.relinquishAt()) {
        mod.form.relinquishAt(datetimeLocalFromTimestamp(Date.now() + (60 * 60 * 1000)));
      }
      if (nextMode === 'duration' && !Number(mod.form.relinquishDuration())) {
        mod.form.relinquishDuration(1);
      }
    }

    function modeButton(nextMode, label) {
      var selected = mode === nextMode;
      return m(plainButton, {
        label: label,
        class: selected ? 'bg-mid-gray' : '',
        style: {
          width: '6rem',
          maxWidth: '6rem',
          minWidth: '6rem',
          marginRight: '0.5rem',
          fontSize: '1rem',
          height: '2.75rem',
          minHeight: '2.75rem',
          maxHeight: '2.75rem',
          lineHeight: '2.75rem',
          color: '#fff',
          opacity: saving ? 0.65 : 1,
        },
        func: function () { selectMode(nextMode); },
      });
    }

    function renderDurationFields() {
      if (mode !== 'duration') return null;
      return renderCenteredControlRow([
        m('span.f2', { style: labelStyle }, 'In'),
        m('div.flex.items-center', [
          m('input', {
            type: 'number',
            min: 1,
            step: 1,
            value: mod.form.relinquishDuration(),
            oninput: function (ev) { mod.form.relinquishDuration(ev.target.value); },
            onchange: function (ev) { mod.form.relinquishDuration(ev.target.value); },
            style: Object.assign({}, smallInputStyle, {
              width: '6rem',
              minWidth: '6rem',
              maxWidth: '6rem',
              marginRight: '0.5rem',
            }),
          }),
          m('select.form-control', {
            value: mod.form.relinquishDurationUnit(),
            onchange: function (ev) { mod.form.relinquishDurationUnit(ev.target.value); },
            style: Object.assign({}, smallInputStyle, {
              width: '9rem',
              minWidth: '9rem',
              maxWidth: '9rem',
            }),
          }, [
            m('option', { value: 'minutes' }, 'minutes'),
            m('option', { value: 'hours' }, 'hours'),
          ]),
        ]),
      ]);
    }

    function renderExactTimeFields() {
      if (mode !== 'at') return null;
      return renderCenteredControlRow([
        m('span.f2', { style: labelStyle }, 'At'),
        m('input', {
          type: 'datetime-local',
          value: mod.form.relinquishAt(),
          oninput: function (ev) { mod.form.relinquishAt(ev.target.value); },
          onchange: function (ev) { mod.form.relinquishAt(ev.target.value); },
          style: Object.assign({}, smallInputStyle, {
            width: '16rem',
            minWidth: '16rem',
            maxWidth: '16rem',
          }),
        }),
      ]);
    }

    function renderExistingSchedule() {
      if (!hasSchedule) return null;
      var text = formatScheduleTime(scheduleRecord.releaseAt);
      if (scheduleRecord.status === 'retry') {
        text += ' (retry pending)';
      } else if (scheduleRecord.status === 'processing') {
        text += ' (releasing)';
      }
      return renderCenteredControlRow([
        m('span.f3.nowrap.yellow', {
          style: controlLabelStyle({
            flex: '0 0 9rem',
            width: '9rem',
            minWidth: '9rem',
            maxWidth: '9rem',
            fontSize: '1.125rem',
          }),
        }, 'Release Scheduled'),
        m('div.flex.items-center', [
          m('span.f3.mr3.nowrap.yellow', { style: { fontSize: '1.125rem' } }, text),
          m(plainButton, {
            label: saving ? 'Canceling' : 'Cancel Release',
            class: 'override-cancel-release-button flex items-center justify-center',
            style: {
              width: '9rem',
              maxWidth: '9rem',
              minWidth: '9rem',
              height: '2.5rem',
              minHeight: '2.5rem',
              maxHeight: '2.5rem',
              borderColor: '#777',
              backgroundColor: 'transparent',
              color: '#ddd',
              fontSize: '0.95rem',
              boxSizing: 'border-box',
              cursor: saving ? 'not-allowed' : 'pointer',
              opacity: saving ? 0.65 : 1,
            },
            func: function () {
              if (!saving) mod.cancelRelinquishSchedule();
            },
          }),
        ]),
      ]);
    }

    var controls = hasSchedule ? [
      renderExistingSchedule(),
    ] : [
      renderCenteredControlRow([
        m('span.f2', { style: labelStyle }, 'Release'),
        m('div.flex', [
          modeButton('none', 'Never'),
          modeButton('duration', 'In'),
          modeButton('at', 'At'),
        ]),
      ]),
      renderDurationFields(),
      renderExactTimeFields(),
    ];

    return m('div.mt4.pt3.bt.b--mid-gray', { 'data-testid': 'override-relinquish-section' }, [
      loading ? m('div.tc.mid-gray.mb2', 'Loading scheduled release...') : null,
    ].concat(controls));
  }

  function renderCommandTab() {
    function renderModeButtons(active) {
      const labelStyle = controlLabelStyle();

      var isManual = isManualMode(active);
      var isAuto = !isManual;
      return renderCenteredControlRow([
        m('span.f2', { style: labelStyle }, 'Mode'),
        m('div.flex', [
            m(plainButton, {
            label: 'Auto',
            class: isAuto ? 'bg-mid-gray' : '',
            // Use same reduced font size as value controls for consistent proportions.
            style: {
              width: '7.5rem',
              maxWidth: '7.5rem',
              minWidth: '7.5rem',
              marginRight: '0.5rem',
              color: '#fff',
              fontSize: buttonFontSize,
              height: '4rem',
              minHeight: '4rem',
              maxHeight: '4rem',
              lineHeight: '4rem',
              boxSizing: 'border-box',
            },
            func: function () {
              mod.form.overridemode(false);
            },
          }),
            m(plainButton, {
            label: 'Manual',
            style: {
              width: '7.5rem',
              maxWidth: '7.5rem',
              minWidth: '7.5rem',
              backgroundColor: isManual ? '#f5c84b' : 'transparent',
              color: isManual ? '#000' : '#fff',
              fontSize: buttonFontSize,
              height: '4rem',
              minHeight: '4rem',
              maxHeight: '4rem',
              lineHeight: '4rem',
              boxSizing: 'border-box',
            },
            class: '',
            func: function () {
              mod.form.overridemode(true);
            },
          })
        ]),
      ]);
    }

    return m('div.mt4', [
      m('div.mb2', [
        renderModeButtons(mod.form.overridemode())
      ]),
      renderOverrideValueControl(),
      renderRelinquishScheduleControl()
    ]);
  }

  function renderHistoryTab() {
    if (!mod.vm.point) {
      return m('div.tc.pa2', 'Loading history...');
    }

    return m('div.mt3', [
      m(pointCommands, {
        pointRid: mod.vm.point['@rid'],
        pageSize: 10,
        pointUnit: mod.vm.point && mod.vm.point.unit,
        dragContainerStyle: { marginRight: '0px' },
      })
    ]);
  }

  return [
      mod.errorView(),
      mod.successView(),
      m('div.page-header.flex.justify-between.items-end', [
        m('div.flex.flex-wrap', {style: {'max-width': '88%'}}, [
          (breadcrumbPath || []).map(function (ancestor, idx) {
            const isLast = idx === lastValidIdx;
            if (ancestor.name === 'root') {
              return m('div')
            } else if (typeof ancestor.name == 'string' && ancestor.name[0] === '-') {
              return;
            } else if (ancestor['@class'] == 'Element' || ancestor['@class'] == 'Dataset' || ancestor['@class'] == 'Column') {
              if (ancestor.url) {
                return m('div.mr2.nowrap.truncate', [
                  m('a', {
                    href: ancestor.url,
                    onclick: () => {
                      modal.vm.close();
                    },
                  }, ancestor.name),
                  !isLast && m('span', ' - ')
                ]);
              } else {
                return m('div.mr2.nowrap.truncate', [
                  ancestor.name,
                  !isLast && m('span', ' - '),
                ])
              }
            } else if (ancestor['@class'] == 'Site' || ancestor['@class'] == 'Building' || ancestor['@class'] == 'Level' || ancestor['@class'] == 'Room' ) {
              return m('div.mr2.nowrap.truncate',[
                m(m.route.Link, {
                  href: `/location/${ancestor['@rid'].slice(1)}${m.route.get().split('?')[1] ? `?${m.route.get().split('?')[1]}`:''}`,
                  onclick: () => {
                    modal.vm.close();
                  },
                }, ancestor['@class'] == 'Room' ? 
                    `${ancestor.name} ${ancestor.roomNumber}` 
                  : 
                    ancestor.name
                ),
                !isLast && ' / '
              ])
            } else if (ancestor['@class'] == 'Dashboard') {
              return m('div.mr2.nowrap.truncate',[
                m(m.route.Link, {
                  href: '/dashboard/' + ancestor['@rid'].slice(1),
                  onclick: () => {
                    modal.vm.close();
                  },
                }, ancestor.name || ancestor['@class']),
                !isLast && ' / '
              ])
            } else {
              const href = '/equipment/' + ancestor['@class'].toLowerCase() + '/' + ancestor['@rid'].slice(1);
              const currentPath = (m.route.get() || '').split('?')[0];
              const isCurrent = currentPath === href;
              return m('div.mr2.nowrap.truncate', [
                isCurrent
                  ? (ancestor.name || ancestor['@class'])
                  : m(m.route.Link, {
                      href,
                      onclick: () => {
                        modal.vm.close();
                      },
                    }, ancestor.name || ancestor['@class']),
                !isLast && ' / '
              ])
            }
          }), 
        ]),
        m(button, {
          class: 'dib ml3 point-detail-modal-link',
          showFeedback: false,
          style: {
            minWidth: '2.1rem',
            paddingTop: '0.05rem',
            paddingBottom: '0.12rem',
            paddingLeft: '0.3rem',
            paddingRight: '0.3rem',
            lineHeight: '1'
          },
          label: m('i.icon.ion-ios-gear.blue', {
            style: {
              'font-size': '1.5rem'
            }
          }),
          func: function () {
            m.route.set(
              '/point/' + String(mod.vm.point['@rid']).slice(1),
              { column: mod.vm.column['@rid'] }
            );
            modal.vm.close()
          }
        })
      ]),
      renderModeSwitch(),
      activeTab === 'command' ? renderCommandTab() : renderHistoryTab()
    ]
};

module.exports = mod;
